import React from "react";
import LegalDocument from "../../features/legal/LegalDocument";

const Terms = () => {
  return (
    <div className="terms-page full-bleed">
      <LegalDocument doc="terms" />
    </div>
  );
};

export default Terms;
